module.exports = __webpack_public_path__ + "img/pod-dex.df144c0e.svg";